import { Box } from "@hiver/hiver-ui-kit";
import {
  FILTER_KEYS,
  OPERATOR_KEYS,
} from "../../../constants/conversationFilter";
import TagsIcon from "../../../images/filterIcons/tags.svg";
import { OPERATOR_SUFFIX } from "../reducer";
import {
  setActiveFilter,
  setFilter,
  setTagsOperator,
  setWithoutTagsOperator,
} from "../reducer/actionCreators";
import FilterHeader from "./FilterHeader";
import { FilterMultiSelect } from "./FilterMultiSelect";
import TagsDropdownRadioSelect from "./TagsDropdownRadioSelect";

const FilterMultiSelectContainer = (props) => {
  const { filterKey, filtersState, filterDispatch } = props;

  const { activeFilter } = filtersState;
  const setSelectedFilter = (name) => {
    filterDispatch(setActiveFilter({ name }));
  };

  const selectedList = filtersState?.[filterKey]?.values ?? [];
  const setSelectedList = ({ name, op, values, custom_field_id }) => {
    filterDispatch(setFilter({ name, op, values, custom_field_id }));
  };

  const setTagsOperation = ({ tagsFilterKey, operator }) => {
    if (tagsFilterKey === FILTER_KEYS.TAGS_FILTER) {
      filterDispatch(setTagsOperator({ operator }));
    } else if (tagsFilterKey === FILTER_KEYS.WITHOUT_TAGS_FILTER) {
      filterDispatch(setWithoutTagsOperator({ operator }));
    }
  };

  const isTagsFilter = [
    FILTER_KEYS.TAGS_FILTER,
    FILTER_KEYS.WITHOUT_TAGS_FILTER,
  ].includes(filterKey);

  const tagsFilterOperation = isTagsFilter
    ? filtersState?.[`${filterKey}${OPERATOR_SUFFIX}`]
    : OPERATOR_KEYS.ANY;

  const extraDropdownComponents = isTagsFilter ? (
    <TagsDropdownRadioSelect
      key={tagsFilterOperation}
      tagsFilterOperation={tagsFilterOperation}
      tagsFilterKey={filterKey}
      filtersState={filtersState}
      setTagsOperation={setTagsOperation}
    />
  ) : null;

  return (
    <Box>
      {filterKey === FILTER_KEYS.TAGS_FILTER && (
        <FilterHeader label="Tags" icon={TagsIcon} />
      )}
      <FilterMultiSelect
        {...props}
        selectedFilter={activeFilter}
        setSelectedFilter={setSelectedFilter}
        selectedList={selectedList}
        setSelectedList={setSelectedList}
        filtersState={filtersState}
        extraDropdownComponents={extraDropdownComponents}
      />
    </Box>
  );
};

export default FilterMultiSelectContainer;
